import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'
import {AssetSchema} from './asset'
import {LinkSchema} from './link'
import {PrimerComponentTimelineSchema} from './primerComponentTimeline'
import {PrimerComponentLabelSchema} from './primerComponentLabel'
import {AnimatedVideoSchema} from './animatedVideo'
import {safeOptional} from '../../safe-optional'

export const PrimerComponentRiverSchema = buildEntrySchemaFor('primerComponentRiver', {
  fields: z.lazy(() =>
    z.object({
      align: z.enum(['start', 'center', 'end']),
      imageTextRatio: z.enum(['50:50', '60:40']),
      label: safeOptional(PrimerComponentLabelSchema),
      heading: z.string().optional(),
      headingRich: safeOptional(RichTextSchema),
      headingLevel: z.enum(['h2', 'h3', 'h4', 'h5', 'h6']).optional(),
      text: RichTextSchema,
      trailingComponent: safeOptional(PrimerComponentTimelineSchema),
      callToAction: safeOptional(LinkSchema),
      callToActionVariant: z.enum(['default', 'accent']).optional(),
      image: safeOptional(AssetSchema),
      imageAlt: z.string().optional(),
      videoSrc: z.string().optional(),
      animatedVideo: safeOptional(AnimatedVideoSchema),
      hasShadow: z.boolean().optional(),
      htmlId: z.string().optional(),
    }),
  ),
})

export type PrimerComponentRiver = z.infer<typeof PrimerComponentRiverSchema>
